import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic } from '../../styles';
export const DEFAULT_CONTAINER_SIZE = '175px';
export const ThumbnailContainer = styled(Grid) `
	height: ${DEFAULT_CONTAINER_SIZE};
	width: ${DEFAULT_CONTAINER_SIZE};
	position: relative;
	text-align: center;
	overflow: hidden;
	align-items: center;
`;
export const ThumbnailItem = styled(Grid) `
	width: 100%;
`;
export const ThumbnailImage = styled('img') `
	height: 100%;
	width: 100%;
	opacity: 1;
	margin: auto;
	position: absolute;
	left: -500%;
	right: -500%;
	top: -500%;
	bottom: -500%;
	object-fit: cover;
	border-radius: ${(props) => (props.isPrimaryImage ? '50%' : '0')};
`;
export const DefaultThumbnailIcon = styled('div') `
	color: ${Magnetic.colorBrand50};
	font-weight: ${Magnetic.fontWeightNormal};
`;
export const StyledAttachmentTypeIcon = styled('span') `
	position: absolute;
	left: ${Magnetic.menuPaddingBottom};
	bottom: ${Magnetic.menuPaddingBottom};
	font-size: ${Magnetic.fontSize26};
	color: ${Magnetic.colorBrand50};
	border: calc(${Magnetic.baseBorderWidth} * 2) ${Magnetic.buttonBorderStyle} ${Magnetic.colorWhite};
	border-radius: ${Magnetic.switchCircleBorderRadius};
	background-color: ${Magnetic.backgroundNeutral0};
`;
export const StyledWarningIcon = styled('span') `
	position: absolute;
	bottom: ${Magnetic.menuPaddingBottom};
	right: ${Magnetic.menuPaddingBottom};
	color: ${Magnetic.annotationAlertColor};
	font-size: ${Magnetic.fontSize22};
`;
//# sourceMappingURL=style.js.map